import Raven from 'raven-js';
import { widgetCtrl as ctrl } from '../../widgetController';
import {
  createEl,
  createScript,
  removeClass,
} from '../../helpers/domHelpers';
import { onMapClick } from '../../helpers/analytics';
import calendar from './calendar';
import styles from '../../css/locations.css';

const GOOGLE_MAPS_KEY = 'AIzaSyDXe1z6Mj3LZSvBnleor9h-zdikTfGqd_M';
// TODO: do this on the backend once for each practice
function geocodeLocations(locations) {
  const geocoder = new google.maps.Geocoder();
  function geocodeAddress(address) {
    return new Promise((resolve, reject) => {
      geocoder.geocode({ address }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          resolve(results[0].geometry.location);
        } else {
          reject(status);
        }
      });
    });
  }
  return Promise.all(locations.map(loc => geocodeAddress(`${loc.street_address}, ${loc.city}, ${loc.state} ${loc.zip}`)));
}

const mapView = {

  init() {
    this.map = null;
    this.markers = [];
    const mapDiv = createEl('div', styles.map);

    const mapLoader = createScript(`https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_KEY}`);
    mapLoader.onload = () => {
      this.initMap(mapDiv);
    };
    document.body.append(mapLoader);

    const locationsContainer = createEl('div', styles.locations);

    // // create map instruction and info boxes for desktop:
    const desktopInfoTopBox = createEl('div', styles.desktopTopBox, 'Click on the icons to change locations');
    this.desktopInfoBottomBox = createEl('div', styles.desktopBottomBox);

    // create open/close map button for mobile:
    const mobileMapToogle = createEl('div', styles.selectToggle);
    const toggleArrow = createEl('div', styles.toggleArrow, 'arrow_drop_up');
    const toggleText = createEl('span', styles.toggleLine);
    toggleText.append(
      createEl('span', styles.toggleText, ctrl.getLocations().length > 1 ? 'choose location' : 'show map'),
      toggleArrow,
    );
    mobileMapToogle.append(
      toggleText,
    );
    let toggleState = styles.isExpanded;

    mobileMapToogle.addEventListener('click', () => {
      removeClass(locationsContainer, toggleState);
      toggleState = toggleState === styles.isExpanded ?
        styles.isHidden :
        styles.isExpanded;

      locationsContainer.className += ` ${toggleState}`;
      toggleArrow.textContent = toggleArrow.textContent === 'arrow_drop_up' ?
        'arrow_drop_down' :
        'arrow_drop_up';
    });
    if (ctrl.getLocations().length > 1) {
      locationsContainer.append(desktopInfoTopBox);
    }
    locationsContainer.append(
      mobileMapToogle,
      mapDiv,
      this.desktopInfoBottomBox,
    );
    return locationsContainer;
  },

  initMap(mapDiv) {
    geocodeLocations(ctrl.getLocations())
    .then((values) => {
      this.map = new google.maps.Map(mapDiv, {
        zoom: 6,
        center: { lat: 0, lng: 0 },
        clickableIcons: false,
        disableDefaultUI: true,
        zoomControl: true,
        maxZoom: 12,
      });

      // this piece ensures map is displayed properly after being hidden
      const bounds = new google.maps.LatLngBounds();
      values.forEach((v) => {
        bounds.extend(v);
      });
      google.maps.event.addDomListener(window, 'resize', () => {
        google.maps.event.trigger(this.map, 'resize');
        this.map.setOptions({ maxZoom: 12 });
        if (ctrl.getLocations().length > 1) {
          this.map.fitBounds(bounds);
        }
        this.map.setOptions({ maxZoom: undefined });
      });
      this.map.fitBounds(bounds);
      ctrl.setLatLngForLocations(values);
      this.initMarkers();
      this.render();
    })
    .catch((err) => {
      ctrl.showError();
      Raven.captureException(JSON.stringify(err));
    });
  },

  initMarkers() {
    ctrl.getLocations().forEach((location) => {
      const marker = new google.maps.Marker({
        position: location.latLng,
        map: this.map,
        zIndex: 10,
        clickable: true,
        title: location.name,
        icon: {
          url: require('../../../assets/map-pin-v2-shadow.png'),
          labelOrigin: new google.maps.Point(27, 22),
          scaledSize: new google.maps.Size(56, 60.5),
        },
      });

      marker.addListener('click', () => {
        // Google Analytics:
        if (process.env.NODE_ENV === 'production') {
          ga('openchair.send', {
            hitType: 'event',
            eventCategory: 'Calendar',
            eventAction: 'locationSelect',
          });
        }
        onMapClick();
        ctrl.setCurrentLocation(location);
        this.render();
        calendar.render();
      });
      this.markers.push({ marker, location });
    });
  },

  render() {
    const currentLocation = ctrl.getCurrentLocation();
    const indicatorData = ctrl.getNumberBookingsAvailableForLocations();
    this.desktopInfoBottomBox.innerHTML = '';
    this.desktopInfoBottomBox.append(
      createEl('span', styles.address, 'Office address:\n'),
      createEl('span', styles.address, `${currentLocation.street_address}\n${currentLocation.city}, ${currentLocation.state} ${currentLocation.zip}`),
    );
    this.markers.forEach(({ marker, location }) => {
      const indicator = indicatorData[location.id]; // has to have a space otherwise google returns [object Object]
      marker.setLabel({
        text: `${indicator || ' '}`,
        color: 'white',
        fontSize: '14px',
        fontWeight: 'bold',
        fontFamily: 'Lato',
      });
      marker.setTitle(`${indicator || 'No'} appointment${indicator === 1 ? '' : 's'} \navailable at ${location.name} this week`);
      if (marker.position === currentLocation.latLng) {
        marker.setOptions({ opacity: 1 });
        marker.setIcon({
          url: require('../../../assets/map-pin-v2-shadow.png'),
          labelOrigin: new google.maps.Point(27, 22),
          scaledSize: new google.maps.Size(56, 60.5),
        });
      } else {
        marker.setOptions({ opacity: 0.75 });
        marker.setIcon({
          url: require('../../../assets/map-pin-v2-shadow.png'),
          labelOrigin: new google.maps.Point(20, 18),
          scaledSize: new google.maps.Size(42, 46),
        });
      }
    });
  },
};

export default mapView;



// WEBPACK FOOTER //
// ./src/views/calendarView/locations.js